const isLocal = typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const environment = {
  production: false,
  apiUrl: isLocal ? 'http://127.0.0.1:8000' : 'https://api.tecnologiaasap.com.br',
  baseUrl: isLocal ? 'http://127.0.0.1:8000' : 'https://api.tecnologiaasap.com.br',
  eventPlatform: 'https://events.hmgasap.com.br'
};
